import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { isIos, isSafari } from '@gan/core/util-device';

/**
 * Chromium's install prompt event, which the DOM typings do not include
 */
export interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

@Injectable()
export class AddToHomeScreenService {
  promptIntercepted$ = new BehaviorSubject(false);
  isStandalone$ = new BehaviorSubject(false);
  deferredPrompt?: BeforeInstallPromptEvent;
  userInstalled$ = new BehaviorSubject(false);
  userDismissed$ = new BehaviorSubject(false);

  iOSSafariHow2$ = this.isStandalone$.pipe(map((isStandalone) => isSafari() && isIos() && !isStandalone));

  browserPromptBtn$ = this.userInstalled$.pipe(map((userInstalled) => !(isSafari() && isIos()) && !userInstalled));

  // called once
  trackStandalone() {
    if (this.checkStandalone()) {
      this.isStandalone$.next(true);
    }
  }

  checkStandalone(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches;
  }

  // called from listener
  trackInstalled() {
    this.userInstalled$.next(true);
  }

  addToHomeScreen() {
    if (!this.deferredPrompt) {
      console.log('deferredPrompt null');

      return;
    }

    // Show the prompt
    this.deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice.then((choiceResult) => {
      console.log('choiceResult', choiceResult);
    });
  }
}
